import { Injectable } from '@angular/core';
import {
  ActivatedRouteSnapshot,
  CanActivateChild,
  Router,
  RouterStateSnapshot,
} from '@angular/router';
import { select, Store } from '@ngrx/store';
import { Observable } from 'rxjs';
import { take, tap } from 'rxjs/operators';
import { environment } from '../../environments/environment';
import {
  hasAddress,
  hasAddressChoices,
  hasMonthlyCosts,
  hasToken,
} from '../state/selectors';

@Injectable({
  providedIn: 'root',
})
export class CanActivateChildGuard implements CanActivateChild {
  constructor(private store: Store, private router: Router) {}

  canActivateChild(
    childRoute: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
  ): Observable<boolean> | Promise<boolean> | boolean {
    const { path } = childRoute.routeConfig;
    switch (path) {
      case 'addresses':
        return this.canActivateAddresses();
      case 'success':
        return this.canActivateSuccess();
      case 'coming-soon':
      case 'coming-soon-success':
      case 'may-be-eligible':
      case 'congratulations-unsecured':
        return this.hasAddress();
      case 'success-improvement':
      case 'success-other':
        return this.canActivateCalculator();
      default:
        return true;
    }
  }

  canActivateCalculator() {
    return this.store.pipe(
      select(hasMonthlyCosts),
      tap((monthlyCosts) => {
        if (
          !(
            environment.featureFlagConfig['yt-13358-prequal-calculator'] &&
            monthlyCosts
          )
        ) {
          this.navigateToApp();
        }
      }),
      take(1)
    );
  }

  canActivateAddresses(): Observable<boolean> {
    return this.store.pipe(
      select(hasAddressChoices),
      tap((addressChoices) => {
        if (!addressChoices) {
          this.navigateToApp();
        }
      }),
      take(1)
    );
  }

  canActivateSuccess(): Observable<boolean> {
    return this.store.pipe(
      select(hasToken),
      tap((token) => {
        if (!token) {
          this.navigateToApp();
        }
      }),
      take(1)
    );
  }

  hasAddress(): Observable<boolean> {
    return this.store.pipe(
      select(hasAddress),
      tap((address) => {
        if (!address) {
          this.navigateToApp();
        }
      }),
      take(1)
    );
  }

  navigateToApp() {
    this.router.navigate(['/']);
  }
}
